import styled, { css } from 'styled-components';
import { CssFromFunction } from '../types/types';

export const CONTAINER_MAX_WIDTH = 1400 as const;

// https://webflow.com/blog/3-new-larger-breakpoints-in-webflow

export function desktop1920pxOrWider(style: CssFromFunction) {
  return css`
    @media (min-width: 1920px) {
      ${style}
    }
  `;
}

export function desktop1440pxOrWider(style: CssFromFunction) {
  return css`
    @media (min-width: 1440px) {
      ${style}
    }
  `;
}

export function desktop1201pxOrWider(style: CssFromFunction) {
  return css`
    @media (min-width: 1201px) {
      ${style}
    }
  `;
}

export function desktop1201px(style: CssFromFunction) {
  return css`
    @media (min-width: 1201px) and (max-width: 1439px) {
      ${style}
    }
  `;
}

export function desktop993px(style: CssFromFunction) {
  return css`
    @media (min-width: 993px) and (max-width: 1200px) {
      ${style}
    }
  `;
}

export function tablet(style: CssFromFunction) {
  return css`
    @media (min-width: 768px) and (max-width: 992px) {
      ${style}
    }
  `;
}

export function xsDevice(style: CssFromFunction) {
  return css`
    @media (max-width: 500px) {
      ${style}
    }
  `;
}

export function mobileOrNarrower(style: CssFromFunction) {
  return css`
    @media (max-width: 767px) {
      ${style}
    }
  `;
}

export function mobileReal(style: CssFromFunction) {
  return css`
    @media (min-width: 501px) and (max-width: 767px) {
      ${style}
    }
  `;
}

export function mobileOrWider(style: CssFromFunction) {
  return css`
    @media (min-width: 501px) {
      ${style}
    }
  `;
}

export function tabletOrWider(style: CssFromFunction) {
  return css`
    @media (min-width: 768px) {
      ${style}
    }
  `;
}

export function tabletOrNarrower(style: CssFromFunction) {
  return css`
    @media (max-width: 992px) {
      ${style}
    }
  `;
}

export function desktop993pxOrWider(style: CssFromFunction) {
  return css`
    @media (min-width: 993px) {
      ${style}
    }
  `;
}

export const MobileOnly = styled.div`
  display: none;
  ${mobileOrNarrower(
    css`
      display: block;
    `,
  )}
`;

export const XsDeviceOnly = styled.div`
  display: none;
  ${xsDevice(
    css`
      display: block;
    `,
  )}
`;

export const MobileOrWiderOnly = styled.div`
  display: none;
  ${mobileOrWider(
    css`
      display: block;
    `,
  )}
`;

export const TabletOnly = styled.div`
  display: none;
  ${tablet(
    css`
      display: block;
    `,
  )}
`;
export const DesktopOnly = styled.div`
  display: none;
  ${desktop993pxOrWider(
    css`
      display: block;
    `,
  )}
`;

export const TabletOrNarrowerOnly = styled.div`
  display: none;
  ${tabletOrNarrower(
    css`
      display: block;
    `,
  )};
`;

export const TabletOrWiderOnly = styled.div`
  display: none;
  ${tabletOrWider(
    css`
      display: block;
    `,
  )};
`;
